// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_ESHOP_PRODUCT_SHORT = "ESHOP";
export const BZ2_NEW_PRODUCT_HOVER = "Nov\u00fd tovar";
export const BZ2_OLD_PRODUCT_HOVER = "Pou\u017eit\u00fd tovar";
export const counter_RATINGS = ["%(counter)s hodnotenie", "%(counter)s hodnotenia", "%(counter)s hodnoten\u00ed"];
export const FROM = "Od";
export const PRODUCT_BOX_MARKET_BUTTON_LABEL = "Kde k\u00fapim";
export const PRODUCT_BOX_WRITE_REVIEW = "Nap\u00ed\u0161 hodnotenie";
export const WIKI_WRITE_YOUR_FIRST_EXPERIENCE = "Bu\u010f prv\u00e1 a nap\u00ed\u0161 hodnotenie";
